import React, { useEffect } from 'react';
import { LANGUAGES, useLanguage } from './LanguageContext';
import './LanguageSwitcher.css';

const IcGlobe = ({ size = 14, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
        <path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" stroke={color} strokeWidth="2" />
    </svg>
);

const IcCheck = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <polyline points="5 12 10 17 19 7" stroke="#237804" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/** Bottom sheet listing the supported languages; picking one applies it at once. */
export function LanguageSheet({ open, onClose }) {
    const { lang, setLang, t } = useLanguage();

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="lang-overlay" onClick={onClose}>
            <div
                className="lang-sheet"
                role="dialog"
                aria-modal="true"
                aria-labelledby="lang-sheet-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="lang-sheet-handle" aria-hidden="true" />
                <p className="lang-sheet-title" id="lang-sheet-title">{t('language.choose')}</p>
                <div role="radiogroup" aria-labelledby="lang-sheet-title">
                    {LANGUAGES.map((l) => (
                        <button
                            key={l.code}
                            type="button"
                            role="radio"
                            aria-checked={lang === l.code}
                            lang={l.code}
                            className={`lang-option${lang === l.code ? ' active' : ''}`}
                            onClick={() => { setLang(l.code); onClose(); }}
                        >
                            <span>{l.label}</span>
                            {lang === l.code && <IcCheck />}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export { IcGlobe };
